import React from "react";

const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "KGK Realty (INDIA) Limited",
    "url": "https://kgkrealty.com/",
    "logo": "https://kgkrealty.com/static/media/logo.dd382f68a474408ccf57.webp",
    "sameAs": [
      "https://www.facebook.com/kgkrealty/",
      "https://www.instagram.com/kgk_realty/",
      "https://twitter.com/KgkRealty/",
      "https://www.youtube.com/@kgkrealty595",
      "https://www.linkedin.com/company/kgk-realty/mycompany",
      "https://kgkrealty.com/"
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "KGK Realty (INDIA) Limited",
    "image": "https://kgkrealty.com/static/media/logo.dd382f68a474408ccf57.webp",
    "@id": "https://kgkrealty.com/",
    "url": "https://kgkrealty.com/",
    "telephone": "+91 9829625005",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Entertainment Paradise Campus Jawahar Circle, Jawahar Lal Nehru Marg",
      "addressLocality": "Jaipur",
      "postalCode": "302017",
      "addressCountry": "IN"
    },
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "opens": "10:00",
      "closes": "18:30"
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
    </>
  );
};

export default StructuredData;
